import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../../context";
import NavbarP from "./NavBarP";
import Rotate from "../Rotate";
import Button from "../Button";
import white_tick from "../../img/white_tick.png";
import {
  userLogs,
  patLogs,
  translateText,
  hasOptionalModule,
  getStatusBar
} from "../../context/utils";
import SafeImage from "../SafeImage";
import { incompleteBlockColor } from "../../utils_new/theme";

let allMandatoryCompleted = true;
let allCompleted = true;
let alignment = false;
let mandatoryMissing = [];
let totalMissing = [];
let logsbugs = true;
let interval;
let totalModuleComplete = "";
let track = null;

const WondleMultipleImage = () => {
  const {
    damageModuleCompleted,
    showAlert,
    config,
    clientId,
    setCurrentBlock,
    currentBlock,
    screen,
    setScreen,
    condition,
    subCondition,
    isLandscape,
    setLandscape,
    mandatory,
    subMandatory,
    completed,
    setCompleted,
    mandatoryCompleted,
    setMandatoryCompleted,
    count1,
    setCount1,
    setStopPing,
    inspectionId,
    showFeedBackWarning,
    tempStream,
    setTempStream,
    isSwitchToLandscape,
    setIsSwitchToLandscape,
    isIOS,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const modalRef = useRef();
  const [render, setRender] = useState(false);
  const [showCompletedNotice, setShowCompletedNotice] = useState(false);

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  window.onresize = () => {
    setLandscape(land());
  };

  const success = () => {
    if (!allMandatoryCompleted || (!allCompleted && !hasOptionalModule(config))) {
      patLogs(
        `Submit button clicked and warning given to user that some module is not completed `,
        inspectionId
      );
      modalRef.current.style.display = "flex";
      return;
    }
    // track.stop();
    clearInterval(interval);
    const elements = document.querySelectorAll(".pingsPort");
    elements.forEach((element) => {
      element.style.top = "0px";
    });
    setScreen("port-success");
    // setScreen("block");
    // setCurrentBlock(config["blocks"][1]);
  };

  const modalSuccess = () => {
    patLogs(
      `Warning given to user, some module is not completed, still clicked to submit button`,
      inspectionId
    );
    clearInterval(interval);
    const elements = document.querySelectorAll(".pingsPort");
    elements.forEach((element) => {
      element.style.top = "0px";
    });
    setScreen("port-success");
  };

  const removeModal = () => {
    modalRef.current.style.display = "none";
  };

  useEffect(() => {
    if (logsbugs) {
      userLogs({ position: 8, last_page: "portrait menu page", inspectionId });
      logsbugs = false;
    }
    setStopPing(true);
    allCompleted = true;
    allMandatoryCompleted = true;
    mandatoryMissing = [];
    totalMissing = [];
    setLandscape(land());
    if (currentBlock.length <= 3) {
      alignment = true;
    }
    Object.keys(subMandatory).map((item) => {
      Object.keys(subMandatory[item]).map((item2) => {
        if (subMandatory[item][item2] === "pending") {
          mandatoryMissing.push(item2);
          allMandatoryCompleted = false;
        }
      });
    });
    Object.keys(subCondition).map((item) => {
      Object.keys(subCondition[item]).map((item2) => {
        if (subCondition[item][item2] === "pending") {
          totalMissing.push(item2);
          allCompleted = false;
        }
      });
    });
    setCount1(count1 + 1);
    if (allCompleted) setCompleted(true);
    if (allMandatoryCompleted) setMandatoryCompleted(true);

    totalModuleComplete = "";
    Object.keys(subCondition).map((e) => {
      if (subCondition[e] === "completed") {
        totalModuleComplete = e + "," + totalModuleComplete;
      }
    });
    userLogs({
      position: 13,
      completed_module: totalModuleComplete,
      inspectionId,
    });
    if (Object.keys(config).includes("TimeOut")) {
      setTimeout(() => {
        if (!["success"].includes(screen)) {
          setScreen("timeOut");
        }
      }, config["TimeOut"]["timeInMinutes"] * 1000 * 60);
    }
    if (isIOS && !isLandscape) {
      const elements = document.querySelectorAll(".pingsPort");
      elements.forEach((element) => {
        element.style.top = "60px";
      });
    }
  }, [isLandscape]);


  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 100);
  }, []);

  useEffect(() => { }, [showFeedBackWarning]);

  // The "Optional" module is not shown as a card - it gets its own entry above
  // the submit button, unlocked only once every other module is completed.
  // `allCompleted` can't be used for that: it also counts the Optional module
  // itself, which would keep the entry disabled forever.
  const blockValues = currentBlock["values"] || [];
  const optionalItem = blockValues.find((item) => item["tag"] === "Optional");
  const menuValues = optionalItem
    ? blockValues.filter((item) => item !== optionalItem)
    : blockValues;
  const blockCondition = subCondition[currentBlock["id"]] || {};
  const optionalEnabled =
    !!optionalItem &&
    menuValues.every((item) => blockCondition[item.name] === "completed");

  const openOptional = () => {
    if (!optionalEnabled) return;
    setCurrentBlock(optionalItem);
    patLogs(`click to ${optionalItem.tag}`, inspectionId);
  };

  const optionalConfigured = hasOptionalModule(config);

  const statusBar = getStatusBar() || [0, 0];
  const capturedCount = Number(statusBar[0]) || 0;
  const totalCount = Number(statusBar[1]) || 0;
  const progressPercentage =
    totalCount > 0
      ? Math.min(Math.round((capturedCount / totalCount) * 100), 100)
      : 0;
  const isComplete = totalCount > 0 && capturedCount >= totalCount;

  const onCompletedClick = (item) => {
    if (!optionalConfigured) return;
    patLogs(
      `click to already completed module ${item.tag}`,
      inspectionId
    );
    setShowCompletedNotice(true);
  };

  return isLandscape ? (
    <Rotate />
  ) : (
    <div
      className="process"
      style={{ position: "relative", justifyContent: "normal" }}
    >
      <NavbarP />
      <div id="scroller-container" style={{ display: "flex", gap: "20px", width: "100%", height: "auto", minHeight: "100dvh", boxSizing: "border-box", padding: "15dvh 0% 24px 0%", flexDirection: "column" }}>
        {
          Object.keys(config).includes("status-bar") &&
          <div className="wondle-status-wrapper">
            <div
              className={`wondle-status-card ${isComplete ? "status-complete" : ""}`}
            >
              <div className="wondle-status-top">
                <span className="wondle-status-label">Photos Captured</span>
                <span className="wondle-status-count">
                  <strong>{capturedCount}</strong>
                  <span className="wondle-status-divider">/</span>
                  <span>{totalCount}</span>
                </span>
              </div>

              <div
                className="wondle-progress-track"
                role="progressbar"
                aria-valuenow={capturedCount}
                aria-valuemin={0}
                aria-valuemax={totalCount}
              >
                <div
                  className="wondle-progress-fill"
                  style={{ width: `${progressPercentage}%` }}
                />
              </div>
            </div>
          </div>
        }
        <div
          className="process-main wondle-menu-grid"
          style={{
            // marginTop: "15dvh",
            height: "auto",
            width: "95%",
            padding: "0px 10px 0px 10px"
          }}
        >
          {menuValues.map((item, index) => {
            if (subCondition[currentBlock["id"]][item.name] === "completed") {
              return (
                <div className="wondle-main-menu" key={index}>
                  {item["mandatory"] ? (
                    item["name"] === "Form Module Portrait" ? (
                      <h4
                        style={{
                          color: config["colors"]["complete-block"],
                          margin: "0px",
                        }}
                        key={index}
                      >
                        {item["id"]}&#42;
                      </h4>
                    ) : (
                      <h4
                        style={{
                          color: config["colors"]["complete-block"],
                          margin: "0px",
                          fontSize: item["name"].length > 15 ? "10px" : "13px"
                        }}
                        key={index}
                      >
                        {item["name"]}&#42;
                      </h4>
                    )
                  ) : (
                    <h4
                      style={{
                        color: config["colors"]["complete-block"],
                        margin: "0px",
                        fontSize: item["name"].length > 15 ? "10px" : "13px"
                      }}
                      key={index}
                    >
                      {item["name"]}
                    </h4>
                  )}
                  <div
                    className="process-vin"
                    style={{
                      border: `2px solid ${config["colors"]["complete-block"]}`,
                      width: "100%",
                      margin: "0px",
                    }}
                    onClick={() => onCompletedClick(item)}
                  >
                    <div className="greenCircleTick">
                      <img src={white_tick} alt="1232"></img>
                    </div>
                    <SafeImage src={item["link"]} alt="123" />
                  </div>
                </div>
              );
            }
            return (
              <div className="wondle-main-menu" key={index}>
                {item["mandatory"] ? (
                  item["name"] === "Form Module Portrait" ? (
                    <h4 style={{ margin: "0px" }} key={index}>
                      {item["id"]}&#42;
                    </h4>
                  ) : (
                    <h4 style={{ margin: "0px", fontSize: item["name"].length > 15 ? "10px" : "13px" }} key={index}>
                      {item["name"]}&#42;
                    </h4>
                  )
                ) : (
                  <h4 style={{ margin: "0px", fontSize: item["name"].length > 15 ? "10px" : "13px" }} key={index}>
                    {item["name"]}
                  </h4>
                )}
                <div
                  className="process-vin"
                  style={{
                    border: `1px solid ${incompleteBlockColor(config)}`,
                    width: "100%",
                    margin: "0px",
                    ...(["vecfleet_prod"].includes(clientId) && item["tag"] === "Odometer" ? { "marginTop": "4px" } : {})
                  }}
                  onClick={() => {
                    if (
                      ["Front Capture", "Back Capture"].includes(item["tag"]) &&
                      Object.keys(config).includes("allowLandscapeBumper") &&
                      isIOS
                    ) {
                      const elements = document.querySelectorAll(".pingsPort");
                      elements.forEach((element) => {
                        element.style.top = "10px";
                      });
                      setIsSwitchToLandscape(true);
                    }
                    setCurrentBlock(item);
                    patLogs(`click to ${item.tag}`, inspectionId);
                  }}
                >
                  <SafeImage src={item["link"]} alt="123" />
                </div>
              </div>
            );
          })}
        </div>
        {optionalItem && (
          <div
            style={{
              width: "95%",
              boxSizing: "border-box",
              padding: "0px 10px 0px 10px",
            }}
          >
            <div
              onClick={openOptional}
              style={{
                border: `1px dashed ${optionalEnabled ? config["colors"]["btn"] : "black"}`,
                borderRadius: "6px",
                padding: "14px 10px",
                textAlign: "center",
                fontSize: "14px",
                color: optionalEnabled ? config["colors"]["btn"] : "black",
                cursor: optionalEnabled ? "pointer" : "default",
                opacity: optionalEnabled ? 1 : 0.7
              }}
            >
              Add additional photos (optional)
            </div>
          </div>
        )}
        <div
          id="menuP-mixed-container"
          style={{
            position: "static",
            marginTop: "auto",
            height: "auto",
            minHeight: "90px",
            justifyContent: "flex-end",
            flexShrink: 0,
          }}
        >
          <div
            className="InternetWarning"
            style={{ justifyContent: "normal", height: "auto" }}
          >
            <p>{showAlert && showAlert}</p>
          </div>
          <div className="modal-btn-container" style={{ width: "100%" }}>
            <Button
              style={{ width: "80%" }}
              text={config["menu-page"]["btn-text"]}
              disabled={!mandatoryCompleted}
              onclick={success}
            />
          </div>
        </div>
      </div>

      {showCompletedNotice && (
        <div
          className="menu-modal-container"
          style={{ display: "flex", position: "fixed", top: "0px", left: "0px", zIndex: 5 }}
        >
          <div className="menu-modal-port completed-notice-modal">
            <h3 style={{ textAlign: "center" }}>
              {Object.keys(config["multiple-image-page"]).includes("completed-popup-text") ? config["multiple-image-page"]["completed-popup-text"] : getTranslateText("Photo complete. Use Additional Photos at the end of the inspection for corrections. [Do not use the back button on your browser]")}
            </h3>
            <div id="closeBtn">
              <Button
                text="Okay"
                onclick={() => setShowCompletedNotice(false)}
                marginDefault="0px"
              />
            </div>
          </div>
        </div>
      )}

      <div ref={modalRef} className="menu-modal-container">
        {!mandatoryCompleted ? (
          <div
            className="menu-modal-port"
            style={{ width: "80%", padding: "2% 5%" }}
          >
            <h3>{config["menu-page"]["mandatory-modal-text"]}</h3>
            <h4 style={{ color: "red" }}>{mandatoryMissing.join(", ")}</h4>
            <div id="closeBtn" style={{ marginBottom: "20px" }}>
              <Button
                text="Close"
                onclick={removeModal}
                marginDefault="0px 25px 0px 25px"
              />
            </div>
          </div>
        ) : mandatoryCompleted && !completed ? (
          <div className="menu-modal-port">
            {!damageModuleCompleted &&
              Object.keys(config["menu-page"]).includes(
                "damageConfirmationPopup"
              ) &&
              damageModuleExists ? (
              <>
                <h3>{config["menu-page"]["damageConfirmationPopup"]}</h3>
                <br></br>
                <br></br>
                <div className="damageConfirmationPopup">
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupYesBtn"]}
                    onclick={() => {
                      modalSuccess();
                      modalRef.current.style.display = "none";
                    }}
                  />
                  <Button
                    text={config["menu-page"]["damageConfirmationPopupNoBtn"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      removeModal();
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="menu-modal-port">
                <h3>{config["menu-page"]["optional-modal-text"]}</h3>
                <h4 style={{ color: "red" }}>{totalMissing.join(", ")}</h4>
                <div className="modal-btn-container">
                  <Button
                    text="Close"
                    onclick={removeModal}
                    marginDefault="0px 25px 0px 25px"
                  />
                  <Button
                    text={config["menu-page"]["modal-btn-next"]}
                    onclick={() => {
                      modalRef.current.style.display = "none";
                      modalSuccess();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default WondleMultipleImage;
